<template>
<div>
    <Header />
    <router-view />
    <Footer />
</div>
</template>

<script>
import Header from '@/components/layouts/HeaderComponent.vue';
import Footer from '@/components/layouts/FooterComponent.vue';

export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style>
/* Add any layout-specific styles here */
</style>
